import type {FilterBarChildProps} from '@/_new-code/products/flexible-web-toolkit/blocks/filter-bar'
import {useAuth} from './auth-provider'

export function useVisibleFilters({
	globalState,
	filterBarKey,
	filterBarOptions,
	additionalFilterBarOptions,
	showAdditionalFilters,
	checkShowAdditionalFilters,
}: Pick<
	FilterBarChildProps,
	| 'globalState'
	| 'filterBarKey'
	| 'filterBarOptions'
	| 'additionalFilterBarOptions'
	| 'showAdditionalFilters'
	| 'checkShowAdditionalFilters'
>): {
	visibleFilterOptions: typeof filterBarOptions
	visibleAdditionalFilterOptionsForUser: typeof additionalFilterBarOptions
	visibleAdditionalFilterOptions: typeof additionalFilterBarOptions
	shouldShowAdditionalFilterButton: boolean
	hasVisibleFilters: boolean
	hasVisibleFiltersOrAdditionalFilters: boolean
} {
	const authState = useAuth()

	const visibleFilterOptions = globalState?.[filterBarKey]
		? filterBarOptions.filter(
				(option) =>
					authState.isBlockVisible(option) &&
					authState.checkUserRoleForBlock(option)
			)
		: []

	const visibleAdditionalFilterOptionsForUser = globalState?.[filterBarKey]
		? additionalFilterBarOptions.filter(
				(option) =>
					authState.isBlockVisible(option) &&
					authState.checkUserRoleForBlock(option)
			)
		: []

	const visibleAdditionalFilterOptions = showAdditionalFilters
		? visibleAdditionalFilterOptionsForUser
		: []

	const shouldShowAdditionalFilterButton =
		checkShowAdditionalFilters &&
		visibleAdditionalFilterOptionsForUser.length > 0

	const hasVisibleFilters =
		visibleFilterOptions.length > 0 ||
		visibleAdditionalFilterOptionsForUser.length > 0

	const hasVisibleFiltersOrAdditionalFilters =
		hasVisibleFilters || visibleAdditionalFilterOptionsForUser.length > 0

	return {
		visibleFilterOptions,
		visibleAdditionalFilterOptionsForUser,
		visibleAdditionalFilterOptions,
		shouldShowAdditionalFilterButton,
		hasVisibleFilters,
		hasVisibleFiltersOrAdditionalFilters,
	}
}
